import { CSVImporter } from 'csv-import-react';
import { useState } from 'react';
import Loading from './Loading';
import Modal from './Modal';

const FileImportModal = ({ isOpen, onClose, doSave, title, template }) => {
    const [isSaving, setIsSaving] = useState(false);
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            widthClass="min-w-[90%] !bg-[#f2f4f7]"
        >
            <h2>{title}</h2>
            <CSVImporter
                style={{
                    height: 'unset',
                }}
                isModal={false}
                modalIsOpen={isOpen}
                modalOnCloseTriggered={onClose}
                darkMode={false}
                onComplete={data => {
                    setIsSaving(true);
                    const promise = doSave(data.rows.map(r => r.values));
                    if (promise) {
                        promise.finally(() => {
                            onClose();
                            setIsSaving(false);
                        });
                    }
                }}
                primaryColor="#2C87F3"
                template={template}
            />
            {isSaving && isOpen && (
                <div className="flex text-lg text-gray-500 bg-[#f2f4f7] rounded-3xl space-x-2 items-center justify-center h-full w-full fixed top-0 left-0 z-[99999]">
                    <Loading hideMessage={true} />
                    <div>Saving...</div>
                </div>
            )}
        </Modal>
    );
};

export default FileImportModal;
